import React from 'react';

import { Col } from '@opendoor/atoms/box';
import { Button } from '@opendoor/atoms/button';
import { Text } from '@opendoor/atoms/text';
import { Navigate, useLocation } from 'react-router';

import { OD_HOMEPAGE_URL } from '../../helpers/globals';

type LocationState = {
  outOfMarket: boolean;
};

const SignUpComplete: React.FC = () => {
  const location = useLocation();

  // Validate state exists, redirect to start if user navigated directly here
  const state = location.state as LocationState | null;
  if (!state) {
    return <Navigate to="/sign-up/start" replace />;
  }

  const { outOfMarket } = state;
  const redirectToHome = () => {
    window.location.assign(`${OD_HOMEPAGE_URL}/w/partner/builder`);
  };

  return (
    <Col className="w-full items-center self-center p-2.5 lg:w-1/3">
      <img
        src="https://images.opendoor.com/source/s3/imgdrop-production/14238827a66c46ecbf8dd32982983700.svg?service=partnership-dashboard-fe"
        alt="Complete Icon"
      />
      <Text as="h4" className="text-subheader-lg py-2 text-center">
        Thank you for your interest in Opendoor's Sales Associate solutions.
      </Text>
      <Text as="p" className="text-body-md py-2 text-center">
        {outOfMarket
          ? "Opendoor doesn't currently serve your market, but we'll let you know as soon as we do!"
          : "We'll be in touch shortly!"}
      </Text>
      <Button
        onClick={redirectToHome}
        analyticsName="partnership-dashboard-fe-sign-up-back-to-homepage"
        variant="primary"
        aria-label="Back to Homepage"
      >
        Back to Homepage
      </Button>
    </Col>
  );
};

export default SignUpComplete;
